import PropTypes from 'prop-types';
import React, { useCallback, useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  Button,
  Text,
  useId,
} from '@fluentui/react-components';
import {
  DeleteRegular,
} from '@fluentui/react-icons';
import { useTagsListStyles } from '../../styles';
import { KeywordTag } from './keyword-tag';

export const KeywordDisplay = ({
  fetchedKeywords,
  onRemoveAllKeywords,
  onRemoveKeyword,
  selectedKeywords,
}) => {
  const i18n = useContext(I18nContext);
  const styles = useTagsListStyles();
  const tagsListId = useId('selectedKeywordsTagsList');
  const tagsListRemoveId = `${tagsListId}-remove`;

  const onRemoveTag = useCallback((removedId) => {
    onRemoveKeyword(removedId);
  }, [onRemoveKeyword]);

  return (
    <div className={styles.root}>
      <div className={styles.tagsToolbar}>
        <Text weight="semibold">
          {i18n.getString(_TL_('Selected keywords'))}
        </Text>
        <Button
          appearance="subtle"
          icon={<DeleteRegular />}
          iconPosition="before"
          onClick={onRemoveAllKeywords}
          size="small"
        >
          {i18n.getString(_TL_('Remove all'))}
        </Button>
      </div>
      <div
        className={styles.tagsList}
        id={tagsListId}
      >
        {selectedKeywords.map((keywordId) => {
          const { id, name } = fetchedKeywords[keywordId];
          return (
            <KeywordTag
              id={id}
              key={id}
              name={name}
              listRemoveId={tagsListRemoveId}
              onRemove={onRemoveTag}
            />
          );
        })}
      </div>
    </div>
  );
};

KeywordDisplay.propTypes = {
  fetchedKeywords: PropTypes.objectOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    impressions: PropTypes.number.isRequired,
  })),
  onRemoveAllKeywords: PropTypes.func.isRequired,
  onRemoveKeyword: PropTypes.func.isRequired,
  selectedKeywords: PropTypes.arrayOf(PropTypes.number).isRequired,
};

KeywordDisplay.defaultProps = {
  fetchedKeywords: null,
};
